import { getAcessToken } from '@/modules/shared/storage';
import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';

const parseEvent = (rawEvent) => {
  const lines = rawEvent
    .split('\n')
    .map((line) => line.trimEnd())
    .filter((line) => line !== '');

  if (lines.length === 0) return null;

  let eventName = 'message';
  const dataLines = [];

  for (const line of lines) {
    if (line.startsWith('event:')) {
      eventName = line.substring(6).trim();
      continue;
    }

    if (line.startsWith('data:')) {
      dataLines.push(line.substring(5).trim());
    }
  }

  if (dataLines.length === 0) return null;

  try {
    return { eventName, data: JSON.parse(dataLines.join('\n')) };
  } catch (error) {
    return null;
  }
};

export const conectarStreamLogs = async(callbacks = {}) => {
  const { onInit, onLog, onClose, onError } = callbacks;

  const baseUrl = process.env.VUE_APP_API_URL;
  const controller = new AbortController();

  const response = await fetch(`${baseUrl}/admin/logs/stream`, {
    headers: {
      Accept: 'text/event-stream',
      Authorization: `bearer ${getAcessToken()}`,
    },
    signal: controller.signal,
  });

  if (!response.ok || !response.body) {
    throw new Error(`Falha ao conectar stream de logs: ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder('utf-8');
  let buffer = '';

  const processarBuffer = () => {
    const eventos = buffer.split(/\r?\n\r?\n/);
    buffer = eventos.pop() ?? '';

    eventos.forEach((eventoBruto) => {
      if (eventoBruto.startsWith(':')) return;

      const evento = parseEvent(eventoBruto);
      if (!evento) return;

      if (evento.eventName === 'init') {
        onInit?.(evento.data);
      }

      if (evento.eventName === 'log') {
        onLog?.(evento.data);
      }
    });
  };

  const loop = async() => {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      processarBuffer();
    }

    onClose?.();
  };

  loop().catch((error) => {
    if (controller.signal.aborted) return;
    onError?.(error);
  });

  return () => {
    controller.abort();
  };
};

export const exportarLogs = async() => {
  const httpClient = authenticatedHttpClientFactory();
  const { data } = await httpClient.get('admin/logs/export', {
    responseType: 'blob',
  });

  return {
    blob: data,
    nomeArquivo: 'logs-api.zip',
  };
};
